import api from '@/api'

export default {
  // 获取球队列表
  getSquadByYouth (params) {
    return api({
      url: '/squad/squadListYouth',
      method: 'GET',
      params
    })
  },
  // 获取球队列表,system
  getSquadBySystem (params) {
    return api({
      url: '/squad/squadListSystem',
      method: 'GET',
      params
    })
  },
  // 获取球队列表 ,org
  getSquadByOrg (params) {
    return api({
      url: '/squad/squadListOrgan',
      method: 'GET',
      params
    })
  },
  // 添加球队
  addSquad (data) {
    return api({
      url: '/squad/squadAdd',
      method: 'POST',
      data
    })
  },
  // 修改球队信息
  updataSquad (data) {
    return api({
      url: '/squad/squadEdit',
      method: 'PUT',
      data
    })
  },
  // 删除球队
  deleteSquad (uuid) {
    return api({
      url: `/squad/squadDelete/${uuid}`,
      method: 'DELETE'
    })
  },
  // 获取球队信息
  getSquadInfo (uuid) {
    return api({
      url: `/squad/squadInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 获取球队信息-教练领队
  getSquadInfoCoach (squadUuid) {
    return api({
      url: `/squad/squadInfoCoach/${squadUuid}`,
      method: 'GET'
    })
  },
  getSquadInfoPlayer () {
    return api({
      url: '/squad/squadInfoPlayer',
      method: 'GET'
    })
  },
  getCoachListYouth (params) {
    return api({
      url: '/squad/leisureListYouth',
      method: 'GET',
      params
    })
  },
  getCoachListYouthAll () {
    return api({
      url: '/squad/leisureListYouthAll',
      method: 'GET'
    })
  },
  getCoachListSystem (params) {
    return api({
      url: '/squad/leisureListSystem',
      method: 'GET',
      params
    })
  },
  getCoachListOrgan (params) {
    return api({
      url: '/squad/leisureListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取会员协会列表
  getOrgListByYouth (params) {
    return api({
      url: '/squad/squadAuthorizationListYouth',
      method: 'GET',
      params
    })
  },
  // 获取会员协会列表
  getOrgListBySystem (params) {
    return api({
      url: '/squad/squadAuthorizationListSystem',
      method: 'GET',
      params
    })
  },
  // 获取会员协会列表
  getOrgListByOrgan (params) {
    return api({
      url: '/squad/squadAuthorizationListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取会员协会列表
  getOrgListByCoachOrLeader (params) {
    return api({
      url: '/squad/squadAuthorizationListCoachOrLeader',
      method: 'GET',
      params
    })
  },
  // 获取青训中心下球队列表
  getFreeSquadList (youthUuid) {
    return api({
      url: `/squad/squadListAll/${youthUuid}`,
      method: 'GET'
    })
  },
  // 为球队绑定教练/领队
  squadBinding (data) {
    return api({
      url: '/squad/squadCoachLeaderBinding',
      method: 'POST',
      data
    })
  },

  //  获取球队列表-GET-可分页--教练调用 自己所在
  getSquadListCoach(params) {
    return api({
      url: '/squad/squadListCoach',
      method: 'GET',
      params
    })
  },

  getSquadListCoachAll() {
    return api({
      url: '/squad/squadListAllCoach',
      method: 'GET',
    })
  },

  // 获取列表 coach 视频用
  getSquadListCoachAllToCoach() {
    return api({
      url: '/squad/youthListAllToCoach',
      method: 'GET',
    })
  },


}
